import { NG_VALUE_ACCESSOR } from "@angular/forms";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  Injector,
} from "@angular/core";

import { simpleCompare } from "../../../utils/base.util";
import { STRING } from "../../../constants/string";
import { HasActivePipe } from "./pipes/hasActive.pipe";
import { SelectCoreComponent } from "../SelectCoreComponent";
import { DomUtil } from "../../../utils/dom.util";
import { KeyNames } from "../../../constants/key-names";

@Component({
  selector: "med-multi-select",
  templateUrl: "./med-multi-select.component.html",
  styleUrls: ["./med-multi-select.component.scss"],
  providers: [{
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MedMultiSelectComponent),
  }],
})
export class MedMultiSelectComponent<OptionValueType> extends SelectCoreComponent<OptionValueType[]> {
  constructor(
    protected override injector: Injector,
    protected override cd: ChangeDetectorRef,
    protected override component: ElementRef,
    private hasActive: HasActivePipe,
  ) {
    super(injector, cd, component);
  }

  override itemSelector = ".med-multiselect-item";

  get title(): string {
    return this.placeholder || STRING.INVISIBLE;
  }

  onClear(event: Event): void {
    event.preventDefault();
    this.value = [];
    this.onToggle(false);
    this.onInput.emit(this.value);
  }

  onSelect(value: OptionValueType): void {
    if (this.disabled) {
      return;
    }

    if (this.hasActive.transform(value, this.value)) {
      this.value = this.value.filter(el => !simpleCompare(el, value));
    } else {
      this.value = this.value.concat([value]);
    }

    this.onInput.emit(this.value);
  }

  override focusNextActiveOption(event: KeyboardEvent): void {
    const { parentElement } = event.target as HTMLElement || {};

    if (parentElement) {
      const nextFocusableItem = this.findNextActiveOption(parentElement, event);
      nextFocusableItem?.focus();
    }
  }

  override findNextActiveOption(item: any, event: KeyboardEvent): HTMLElement | null {
    const nextItem = event.key === KeyNames.ARROW_DOWN
      ? item.nextElementSibling
      : item.previousElementSibling;

    if (nextItem) {
      return DomUtil.hasClass(nextItem.children[0], "disabled")
        ? this.findNextActiveOption(nextItem, event)
        : nextItem.children[0];
    }

    return  null;
  }
}
